import React, { Component, PropTypes } from 'react';
import styles from './MainPageCarBrandList.scss';
import config from '../../../config';
import MobileCarBrandListCarousel from './MobileCarBrandListCarousel'
import _ from 'lodash';
import Media from 'react-responsive';
import {Link} from 'react-router';



export default class MainPageCarBrandList extends Component {
    constructor(props, context){
      super(props, context);
      this.props.getBrands();
    }
  render() {
    const brandList = _.sortBy(this.props.brandList, [(brand) => brand.brandName.toLowerCase()]);
    const brandLink = config.routes.catalog;

    const brands = _(brandList).map((brand, i, list) => {
      const brandCapitalLetter = list[i-1] && list[i-1].brandName[0] === list[i].brandName[0]
      ? '' : brand.brandName[0];
      return (
        <div
          key={i}
          data-capital={brandCapitalLetter || ''}
          className={styles.brand}>
          <Link
            to={`${brandLink}/${brand.brandId}`}
            key={`brand{i}`}
            >
            {brand.brandName}
          </Link>
        </div>
      );
    }).value();
    return (
      <div className={ styles.carBrandListContainer }>
        <Media query="(min-width: 1025px)">
          <h2 className={styles.header}>
            Подбор запчастей для технического обслуживания
          </h2>
        </Media>
        <Media query="(max-width: 1024px)">
          <h3 className={styles.mobileHeader}>
            Подбор запчастей для ТО
          </h3>
        </Media>
        <Media query="(min-width: 1025px)">
          <ul className={styles.carBrandList}>
            {brands}
          </ul>
        </Media>
        <Media query="(max-width: 1024px)">
          <MobileCarBrandListCarousel items={brands} />
        </Media>
      </div>
    );
  }
}

MainPageCarBrandList.propTypes = {
  brandList: React.PropTypes.array
};



/** WEBPACK FOOTER **
 ** ./src/components/MainPage/elements/MainPageCarBrandList.jsx
 **/